import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, Copy, Trash2, Pencil, ImageOff, CheckCircle2, Circle } from "lucide-react";
import { fileUrl } from "../../lib/reportApi";

export default function SortableReportItem({ item, index, canEdit, canApprove, onOpen, onDuplicate, onDelete, onToggleApproval }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: item.id, disabled: !canEdit });
  const style = { transform: CSS.Transform.toString(transform), transition, zIndex: isDragging ? 20 : undefined };
  return (
    <li ref={setNodeRef} style={style} data-testid={`report-item-row-${item.id}`}
      className={`mc-panel flex items-center gap-3 p-2 md:p-3 ${isDragging ? "shadow-lg ring-2 ring-black/10" : ""}`}>
      {canEdit && (
        <button type="button" {...attributes} {...listeners} className="cursor-grab active:cursor-grabbing touch-none p-1 text-zinc-400 hover:text-black" aria-label="Drag to reorder" data-testid={`report-item-drag-${item.id}`}>
          <GripVertical className="w-5 h-5" />
        </button>
      )}
      <span className="font-mono-live text-xs text-zinc-400 w-6 text-right">{index + 1}</span>
      <button type="button" onClick={onOpen} className="shrink-0" data-testid={`report-item-thumb-${item.id}`}>
        {item.photo ? (
          <img src={fileUrl(item.photo)} alt="" className="w-16 h-12 md:w-20 md:h-14 object-cover bg-zinc-100" loading="lazy" />
        ) : (
          <div className="w-16 h-12 md:w-20 md:h-14 bg-zinc-100 flex items-center justify-center text-zinc-400"><ImageOff className="w-4 h-4" /></div>
        )}
      </button>
      <button type="button" onClick={onOpen} className="flex-1 min-w-0 text-left">
        <div className={`text-sm font-medium truncate ${item.heading ? "" : "text-zinc-400 italic"}`}>{item.heading || "Untitled — add a heading"}</div>
        <div className="text-xs text-zinc-500 truncate">{item.description || "No description"}</div>
      </button>
      <span className="hidden sm:inline border border-cmdBorder px-2 py-0.5 text-[10px] uppercase tracking-widest font-mono-live" data-testid={`report-item-layout-badge-${item.id}`}>{item.layout}/page</span>
      {canApprove ? (
        <button type="button" onClick={onToggleApproval} title={item.approved ? "Approved — click to un-approve" : "Approve item"} data-testid={`report-item-approve-${item.id}`}
          className={item.approved ? "text-readyGreen" : "text-zinc-300 hover:text-readyGreen"}>
          {item.approved ? <CheckCircle2 className="w-5 h-5" /> : <Circle className="w-5 h-5" />}
        </button>
      ) : (
        item.approved && <CheckCircle2 className="w-5 h-5 text-readyGreen" data-testid={`report-item-approved-${item.id}`} />
      )}
      <div className="flex items-center gap-1">
        <button type="button" onClick={onOpen} className="border border-cmdBorder p-1.5" title="Edit" data-testid={`report-item-edit-${item.id}`}><Pencil className="w-3.5 h-3.5" /></button>
        {canEdit && (
          <>
            <button type="button" onClick={onDuplicate} className="border border-cmdBorder p-1.5 hidden sm:block" title="Duplicate" data-testid={`report-item-duplicate-${item.id}`}><Copy className="w-3.5 h-3.5" /></button>
            <button type="button" onClick={onDelete} className="border border-cmdBorder hover:border-incidentRed hover:text-incidentRed p-1.5" title="Delete" data-testid={`report-item-delete-${item.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
          </>
        )}
      </div>
    </li>
  );
}
